const t = (en, pt, fr, es) => ({ en, pt, fr, es });

export const fullMenu = {
  footerNote: t(
    "* Main courses are served with: Vegetables, Fries, Boiled Potatoes and/or Rice.",
    "* Pratos principais servidos com: Legumes, Batata Frita, Batata Cozida e/ou Arroz.",
    "* Tous les plats principaux : Légumes, Frites, Pommes de terre et/ou Riz.",
    "* Platos principales con: Verduras, Patatas Fritas, Patatas Cocidas y/o Arroz."
  ),
  categories: [
    {
      id: "starters",
      label: t("Starters", "Entradas", "Entrées", "Entrantes"),
      items: [
        { id: "st-1", availability: "all_day", signature: true, name: t("Couvert (Bread, Olives, Pâté, Carrots)", "Couvert (Pão, Azeitonas, Paté, Cenoura)", "Couvert", "Couvert") },
        { id: "st-2", availability: "all_day", name: t("Soup of the Day", "Sopa do Dia", "Soupe du Jour", "Sopa del Día") },
        { id: "st-3", availability: "all_day", name: t("Garlic Bread", "Pão de Alho", "Pain à l'ail", "Pan de Ajo") },
        { id: "st-4", availability: "all_day", name: t("Garlic Bread with Cheese", "Pão de Alho com Queijo", "Pain à l'ail au fromage", "Pan de Ajo con Queso") },
        { id: "st-5", availability: "all_day", name: t("Melon with Smoked Ham", "Melão com Presunto", "Melon au jambon", "Melón con Jamón") },
        { id: "st-8", availability: "all_day", signature: true, name: t("Garlic Prawns", "Camarão ao Alho", "Gambas à l'ail", "Gambas al ajillo") },
        { id: "st-9", availability: "all_day", name: t("Mussels Bulhão Pato Style", "Mexilhão à Bulhão Pato", "Moules Bulhão Pato", "Mejillones") }
      ]
    },
    {
      id: "snacks-salads",
      label: t("Salads & Snacks (until 18:00h)", "Saladas & Snacks (até às 18:00h)", "Salades et Snacks", "Ensaladas y Snacks"),
      items: [
        { id: "dk-1", availability: "until_18", signature: true, name: t("Full English Breakfast", "Pequeno Almoço Inglês", "Petit-Déjeuner", "Desayuno") },
        { id: "ts-1", availability: "until_18", signature: true, name: t("Mixed Toast on Home-made Bread", "Tosta Mista em Pão Caseiro", "Toast Mixte", "Tostada Mixta") },
        { id: "hb-1", availability: "until_18", signature: true, name: t("Monte Sol Burger", "Hambúrguer Monte Sol", "Burger Monte Sol", "Hamburguesa Monte Sol") },
        { id: "bg-1", availability: "until_18", name: t("American Baguette", "Baguete Americana", "Baguette Américaine", "Baguette Americana") },
        { id: "sl-1", availability: "until_18", signature: true, name: t("Tropical Salad (Prawns & Fruit)", "Salada Tropical (Camarão & Fruta)", "Salade Tropicale", "Ensalada Tropical") },
        { id: "sl-2", availability: "until_18", name: t("Country Style Salad (Goat Cheese)", "Salada Campestre (Queijo de Cabra)", "Salade Campagnarde", "Ensalada Campestre") },
        { id: "sl-3", availability: "until_18", name: t("Tuna Fish Salad", "Salada de Atum", "Salade au Thon", "Ensalada de Atún") },
        { id: "om-1", availability: "until_18", name: t("Omelettes (Cheese, Ham, Mushrooms or Prawns)", "Omeletes (Queijo, Fiambre, Cogumelos ou Camarão)", "Omelettes", "Omelets") }
      ]
    },
    {
      id: "meat",
      label: t("Meat Dishes", "Pratos de Carne", "Viandes", "Carnes"),
      items: [
        { id: "sp-1", availability: "all_day", signature: true, name: t("Fillet Steak on Hot Stone", "Bife do Lombo na Pedra", "Filet sur Pierre", "Solomillo a la Piedra") },
        { id: "sp-3", availability: "all_day", name: t("T-Bone Steak", "Bife T-Bone", "Steak T-Bone", "T-Bone") },
        { id: "sp-2", availability: "all_day", name: t("Lamb Shank", "Chambão de Borrego", "Jarret d'agneau", "Garrón de Cordero") },
        { id: "mt-1", availability: "all_day", name: t("Chicken Breast Piri-Piri", "Peito de Frango Piri-Piri", "Poulet Piri-Piri", "Pollo Piri-Piri") },
        { id: "mt-2", availability: "all_day", name: t("Chicken Breast w/ Mushroom Sauce", "Peito de Frango c/ Molho Cogumelos", "Poulet aux champignons", "Pollo con champiñones") },
        { id: "mt-4", availability: "all_day", name: t("Spareribs w/ BBQ Sauce", "Entrecosto c/ Molho BBQ", "Travers de porc BBQ", "Costillas BBQ") },
        { id: "mt-8", availability: "all_day", name: t("Lamb Chops w/ Mint Sauce", "Costeletas de Borrego c/ Molho Hortelã", "Côtelettes d'agneau", "Chuletas de Cordero") }
      ]
    },
    {
      id: "fish",
      label: t("Fish & Seafood", "Peixe & Marisco", "Poissons", "Pescados"),
      items: [
        { id: "se-1", availability: "all_day", signature: true, name: t("Monkfish Kebab w/ Prawns", "Espetada de Tamboril com Gambas", "Brochette de lotte", "Brocheta de Rape") },
        { id: "se-2", availability: "all_day", name: t("Grilled Wild Salmon", "Salmão Selvagem Grelhado", "Saumon sauvage", "Salmón Salvaje") },
        { id: "se-3", availability: "all_day", name: t("Sea Bass Fillet", "Filete de Robalo", "Filet de bar", "Filete de Lubina") },
        { id: "se-4", availability: "all_day", name: t("Prawn or Monkfish Curry", "Caril de Camarão ou Tamboril", "Curry de crevettes ou lotte", "Curry de gambas o rape") }
      ]
    },
    {
      id: "pizzas",
      label: t("Pizzas", "Pizzas", "Pizzas", "Pizzas"),
      items: [
        { id: "pz-1", availability: "all_day", name: t("Margherita", "Margherita", "Margherita", "Margherita") },
        { id: "pz-3", availability: "all_day", name: t("Pepperoni", "Pepperoni", "Pepperoni", "Pepperoni") },
        { id: "pz-6", availability: "all_day", signature: true, name: t("Special Monte Sol", "Pizza Monte Sol", "Pizza Monte Sol", "Pizza Monte Sol") }
      ]
    },
    {
      id: "desserts",
      label: t("Desserts", "Sobremesas", "Desserts", "Postres"),
      items: [
        { id: "ds-1", availability: "all_day", signature: true, name: t("Apple Pie w/ Ice Cream", "Tarte de Maçã c/ Gelado", "Tarte aux pommes", "Tarta de Manzana") },
        { id: "ds-2", availability: "all_day", name: t("Chocolate Mousse", "Mousse de Chocolate", "Mousse au chocolat", "Mousse de Chocolate") },
        { id: "ds-5", availability: "all_day", name: t("Banoffee Pie", "Tarte Banoffee", "Tarte Banoffee", "Tarta Banoffee") }
      ]
    }
  ]
};
